<script setup lang="ts">
import type { ICellRendererParams } from "ag-grid-community";
import { computed } from "vue";

import { copyAndNotify } from "~/components/notifications";
import TaskClickWrapper from "~/components/visualization/components/TaskClickWrapper.vue";
import { EditorMode } from "~/shared/enums";
import type { VisualizationItemTask } from "~/shared/types";
import { useAsyncTask } from "~/utils/entityIncrementalLoading";

const props = defineProps<{
  params: ICellRendererParams<VisualizationItemTask>;
}>();

const { task } = useAsyncTask(computed(() => props.params?.data?.duid));

const copy = () => {
  if (!task.value) {
    return;
  }
  copyAndNotify("DUID", task.value.duid);
};
</script>

<template>
  <TaskClickWrapper v-if="task" :task="task" :editor-mode="EditorMode.LIST">
    <template #default="args">
      <div
        v-if="!params.data?.absentee"
        v-bind="args"
        class="flex size-full items-center p-1 font-mono text-[10px] tracking-tighter"
        @click="copy"
        @keydown.enter="copy">
        {{ task.duid }}
      </div>
    </template>
  </TaskClickWrapper>
</template>
